<template>
  <!-- start: header -->
  <header>
    <div class="logo-container">
      <a href="/" class="logo">
        <img src="../assets/logotipo.png" width="90" height="30" alt="Bo'ol" />
      </a>
    </div>
  </header>
  <!--end: header -->
</template>
<script>
  export default {
    name: 'NavbarLogotipo',
    data(){
      return{
        step:localStorage.step
      }
    }
  }
</script>
<style scoped>
header {
	height: 50px;
	left: 0;
	right: 0;
	top: 0;
  position: fixed;
}
.logo-container {
  background-color: #d6d4d4;
  height: inherit;
}
.logo-container .logo {
  float: none;
  display: inline-block;
  line-height: 50px;
  margin-top: 5px;
  margin-left:15px;
  position: relative;
}
</style>